module.exports = __webpack_public_path__ + "img/law.894d394b.png";